export const getActivity = (state, res) => {
  state.activities = res
}

export const getActivityDetail = (state, res) => {
  state.activityDetail = res
}

export const getActivityDaily = (state, res) => {
  state.dailyActivities = res
}

export const dailyActivityForm = (state, val) => {
  state.dailyActivity = val
}

// daily activity type
export const getDailyType = (state, val) => {
  state.dailyTypes = val
}

export const listDailyActivityType = (state, val) => {
  state.listDailyActivityType = val
}

export const dailyTypeForm = (state, val) => {
  state.dailyType = val
}

export const dailyTypeFormReset = state => {
  state.dailyType = {
    name: ''
  }
}

export const activityTableSort = (state, val) => {
  let oldVal = state.activityTableSort

  if (oldVal.sortBy == val) {
    state.activityTableSort.sortDesc = !oldVal.sortDesc
  } else {
    state.activityTableSort = {
      sortBy: val,
      sortDesc: true
    }
  }
}

export const dailyTableSort = (state, val) => {
  let oldVal = state.daSort

  if (oldVal.sortBy == val) {
    state.daSort.sortDesc = !oldVal.sortDesc
  } else {
    state.daSort = {
      sortBy: val,
      sortDesc: true
    }
  }
}

// action
export const getActivityAction = (state, val) => {
  state.actions = val
}

export const activityActionForm = (state, val) => {
  state.action = val
}

export const activityActionFormReset = state => {
  state.action = {
    name: ''
  }
}

export const getSalesHaveCustomer = (state, val) => {
  state.haveCustomer = val
}

export const getCustomerHaveSales = (state, val) => {
  state.haveSales = val
}

export const todayTable = (state, val) => {
  state.today.tables = val
}

export const todayMap = (state, val) => {
  state.today.maps = val
}

export const getWeekly = (state, val) => {
  state.weekly = val
}

export const getSalesActivity = (state, res) => {
  state.salesActivity = res
}

export const detailSalesActivity = (state, res) => {
  state.salesActivityDetail = res
}
